import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadReceipt = (context, receiptData) => new Promise((resolve, reject) => {
  Api.folderService.getInspectionReceipt(receiptData.folderId, receiptData.paymentId)
    .then(response => {
      context.commit('setReceipt', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setReceipt', {});
      Http.setGlobalError(context, Http.createError(error, 'receipt.actions.loadReceipt', { receiptData }));
      reject();
    });
});

export default {
  loadReceipt,
};
